import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/baseUi/tabs"
import { cn } from "@/modules/lib/utils"
import { word } from "@modules/core/utils/i18n"
import { ProgramInfoDetails } from "@modules/programs/components/programInfoDetails"
import { ProgramInfoHeader } from "@modules/programs/components/programInfoHeader"
import { useProgramRights } from "@modules/programs/hooks/useProgramRights"
import { useProgram } from "@modules/programs/hooks/usePrograms"
import { ProgramSubscribersListWrapper } from "@modules/programs/programSubscriber/components/programSubscribersListWrapper"
import { ProgramType } from "@modules/programs/types/programTypes"
import { useSidebar } from "@modules/sidebar/hooks/useSidebar"
import { LoadingSpinner } from "@modules/ui/components/loading"
import { startTransition, Suspense } from "react"

type ProgramInfoWrapperProps = {
  programId: string
  editionAllowed?: boolean
  className?: string
} & React.ComponentProps<"div">

export function ProgramInfoWrapper({ programId, editionAllowed = true, className, ...props }: ProgramInfoWrapperProps) {
  const { setCurrentStackState, getCurrentStackState } = useSidebar()
  const activeIndex = getCurrentStackState("activeIndex") || "0"
  const { data: program } = useProgram(programId)
  const { isAuthor, isAcceptedSharedCoach } = useProgramRights(programId)

  function selectTab(index: string) {
    startTransition(() => {
      setCurrentStackState("activeIndex", index)
    })
  }

  return (
    <Suspense fallback={<LoadingSpinner />}>
      <div className={cn("flex grow flex-col", className)} {...props}>
        <ProgramInfoHeader programId={programId} />
        {isAuthor || isAcceptedSharedCoach ? (
          <Tabs defaultValue={activeIndex} className="relative flex w-full flex-col">
            <TabsList variant="program">
              <TabsTrigger
                variant="program"
                onClick={() => {
                  selectTab("0")
                }}
                value="0"
              >
                {word("global.details")}
              </TabsTrigger>
              <TabsTrigger
                variant="program"
                onClick={() => {
                  selectTab("1")
                }}
                value="1"
              >
                {program.type === ProgramType.ONOFF
                  ? word("global.athlete", { count: 2 })
                  : word("program.label.subscribers")}
              </TabsTrigger>
            </TabsList>
            <TabsContent value="0" className="flex w-full">
              <Suspense fallback={<LoadingSpinner className="pt-18" />}>
                <ProgramInfoDetails programId={programId} editionAllowed={editionAllowed} className="pt-18" />
              </Suspense>
            </TabsContent>
            <TabsContent value="1" className="flex w-full">
              <Suspense fallback={<LoadingSpinner className="pt-18" />}>
                <ProgramSubscribersListWrapper programId={programId} />
              </Suspense>
            </TabsContent>
          </Tabs>
        ) : (
          <ProgramInfoDetails programId={programId} editionAllowed={editionAllowed} />
        )}
      </div>
    </Suspense>
  )
}
